<div class="flex flex-column gap-3">
    <p-card *ngIf="groupedConfigurations.length == 0" styleClass="text-center">
        No hay datos de configuración.
    </p-card>
    <p-card *ngFor="let grp of groupedConfigurations" styleClass="p-card-content-no-padding p-card-body-pt-0">
        <ng-template pTemplate="header">
            <div class="flex align-items-center">
                <h3>{{ grp.group }}</h3>
            </div>
        </ng-template>

        <div>
            <p-table [value]="grp.items">
                <ng-template pTemplate="header">
                    <tr>
                        <th width="250">Nombre</th>
                        <th width="400">Descripción</th>
                        <th>Valor</th>
                        <th width="50"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-configuration>
                    <tr>
                        <td>{{ configuration.name }}</td>
                        <td>{{ configuration.description }}</td>
                        <td>
                            <div class="col-12 input-field">
                                <input *ngIf="configuration.controlType=='input-text'" pInputText
                                    [(ngModel)]="configuration.value"
                                    [disabled]="configuration.system"
                                        />
                                <p-password *ngIf="configuration.controlType=='input-password'"
                                    [(ngModel)]="configuration.value"
                                    [disabled]="configuration.system"
                                    [toggleMask]="true"
                                    [feedback]="false"
                                    styleClass="w-full" inputStyleClass="w-full"
                                        />
                                <p-inputNumber *ngIf="configuration.controlType=='input-number'"
                                    [(ngModel)]="configuration.value"
                                    [disabled]="configuration.system"
                                    [minFractionDigits]="0"
                                    [maxFractionDigits]="configuration.dataType=='decimal' ? 2 : 0"
                                    [min]="$any(configuration).min"
                                    [max]="$any(configuration).max"
                                        />
                                <p-dropdown *ngIf="configuration.controlType=='dropdown'"
                                    [options]="configuration.options"
                                    optionLabel="text" optionValue="value"
                                    [(ngModel)]="configuration.value"
                                    [disabled]="configuration.system"
                                    showClear
                                    (onClick)="getValue($event)"
                                    appendTo="body"
                                    placeholder="Seleccione..." class="w-full"
                                    >
                                </p-dropdown>
                                <p-dropdown *ngIf="configuration.controlType=='checkbox'"
                                    [options]="booleanOptions"
                                    optionLabel="label" optionValue="value"
                                    [(ngModel)]="configuration.value"
                                    [disabled]="configuration.system"
                                    showClear
                                    placeholder="Seleccione..."
                                    appendTo="body"
                                    class="w-full">
                                </p-dropdown>
                            </div>
                        </td>
                        <td>
                            <p-button *ngIf="allowWrite && !configuration.system"
                                icon="pi pi-check"
                                [rounded]="true"
                                [text]="true"
                                (click)="saveValue(configuration)">
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>
